export default __webpack_public_path__ + "static/media/0x34c1b299a74588d6abdc1b85a53345a48428a521.435d195d.webp";